// extracted by mini-css-extract-plugin
module.exports = {"wrap":"To-z","heading":"Uo-z","brandPromo":"Vo-z"};